import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { RootState } from '../store/store';
import { setInitialized, clearUser } from '../store/userSlice';
import { authService } from '../services/apiService';

interface AuthInitializerProps {
  children: React.ReactNode;
}

const AuthInitializer: React.FC<AuthInitializerProps> = ({ children }) => {
  const dispatch = useDispatch();
  const user = useSelector((state: RootState) => state.user.user);
  const isInitialized = useSelector((state: RootState) => state.user.isInitialized);

  useEffect(() => {
    const initializeAuth = async () => {
      try {
        // If we have a user in state, validate their token
        if (user && user.token) {
          try {
            // Try to get user profile to validate token
            await authService.getProfile(user);
            // If successful, token is still valid
          } catch (error) {
            console.error('Token validation failed:', error);
            // Token is invalid, clear user
            dispatch(clearUser());
          }
        }
      } catch (error) {
        console.error('Auth initialization error:', error);
        dispatch(clearUser());
      } finally {
        dispatch(setInitialized());
      }
    };

    if (!isInitialized) {
      initializeAuth();
    }
  }, [dispatch, user, isInitialized]);

  // Show loading while initializing
  if (!isInitialized) {
    return (
      <div style={{
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        height: '100vh',
        fontSize: '18px'
      }}>
        Loading...
      </div>
    );
  }

  return <>{children}</>;
};

export default AuthInitializer; 